import { useForm } from '@tanstack/react-form'
import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useForgotPasswordMutation } from '../hooks'
import { LoginSchema } from '../schema/loginSchema'
import { FormInput } from '@/components/custom/form-input'
import LoadingButton from '@/components/custom/loading-button'
import { Modal } from '@/components/custom/modal'
import { Button } from '@/components/ui/button'

export function ForgotPassword() {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const { mutate: forgotPasswordMutation, isPending } =
    useForgotPasswordMutation(() => {
      const email = form.state.values.email
      form.reset()
      setIsOpen(false)
      navigate({
        to: '/password-requested',
        search: { email },
      })
    })

  const form = useForm({
    defaultValues: {
      email: '',
    },
    onSubmit: ({ value }) => {
      forgotPasswordMutation(value.email)
    },
  })

  return (
    <>
      {/* Trigger Button */}
      <Button
        variant="link"
        className="px-0 text-sm mt-4 h-auto"
        onClick={() => setIsOpen(true)}
      >
        Forgot your password?
      </Button>

      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="Password Recovery"
        contentClassName="sm:max-w-lg max-w-[95%] rounded-md"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            form.handleSubmit()
          }}
          className="space-y-4"
        >
          <form.Field
            name="email"
            validators={{
              onBlur: ({ value }) => {
                const result = LoginSchema.shape.email.safeParse(value)
                return result.success
                  ? undefined
                  : result.error.errors[0].message
              },
            }}
            children={(field) => {
              return (
                <div className="gap-0">
                  <FormInput
                    field={field}
                    label="Email"
                    type="email"
                    placeholder="you@example.com"
                    autoComplete="off"
                    id={field.name}
                    name={field.name}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(e) => field.handleChange(e.target.value)}
                  />
                </div>
              )
            }}
          />

          <form.Subscribe
            selector={(state) => [state.canSubmit, state.isSubmitting]}
            children={([canSubmit]) => (
              <LoadingButton
                type="submit"
                className="w-full"
                isLoading={isPending}
                disabled={!canSubmit || isPending}
              >
                {isPending ? 'Sending...' : 'Send recovery email'}
              </LoadingButton>
            )}
          />
        </form>
      </Modal>
    </>
  )
}
